export default __webpack_public_path__ + "bannere255f4.png";